import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.array.iterator";
import stickybits from "stickybits";
//@ts-ignore
import { create } from "@wkWebSrc/js/components/pagination";
//@ts-ignore
import { EMAIL_REGEX, PHONE_REGEX, DATE_REGEX, EXCLUDED_REGEX } from "@utils/RegexUtils";
//@ts-ignore
import { shallowCopyObjectTo } from "@utils/ObjectUtils";
export var page = [];
export var LISTING_MODE;
(function (LISTING_MODE) {
  LISTING_MODE["MAP"] = "Mappa";
  LISTING_MODE["LIST"] = "Lista";
})(LISTING_MODE || (LISTING_MODE = {}));
var ListingInit = {
  click: true
};
export function init(opts) {
  shallowCopyObjectTo(opts, ListingInit);
  var insertionsListEl = document.querySelectorAll(".insertion");
  var _iterator = _createForOfIteratorHelper(insertionsListEl),
    _step;
  try {
    var _loop = function _loop() {
      var insertion = _step.value;
      var _insertion$dataset = insertion.dataset,
        url = _insertion$dataset.url,
        id = _insertion$dataset.id,
        agencyId = _insertion$dataset.agencyId;
      page.push({
        id: parseInt(id || "".concat(-1)),
        agencyId: parseInt(agencyId || "".concat(-1)),
        url: url
      });
      var descriptionEl = insertion.querySelector(".description");
      var text = descriptionEl === null || descriptionEl === void 0 ? void 0 : descriptionEl.innerHTML.trim();
      if (!text || !descriptionEl) return 1; // continue
      text = text === null || text === void 0 ? void 0 : text.replace(EMAIL_REGEX, "***");
      text = text === null || text === void 0 ? void 0 : text.replace(PHONE_REGEX, function (match, p1, p2, p3, offset) {
        if (p1) return match;
        if (match.match(DATE_REGEX)) return match;
        var start = Math.max(0, offset - 6);
        var tmp = text === null || text === void 0 ? void 0 : text.substring(start, offset).toLowerCase();
        return EXCLUDED_REGEX.some(function (s) {
          return (tmp || "").indexOf(s.toLowerCase()) > -1;
        }) ? match : "***";
      });
      descriptionEl.innerHTML = text;
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  stickybits("#listing-header", {
    useStickyClasses: true
  });
  if (!window["_count"] || !window["_currentPage"] || !window["_pageSize"]) return;
  var match = window.location.href.match(/(^[^#]*)/);
  var backURL = match ? match[0] : "";
  create(window["_count"], window["_pageSize"], window["_currentPage"], page, window["_serializedSearchBean"], backURL);
}